import React from 'react';

import AllCourses from "../components/common/AllCourses";
import Header from "../components/LandingPageAppBar";
const LandPage =()=>{

  return (
    <>
    <Header/>
    <AllCourses/>
    </>
  )
}

export default LandPage;